export const indexURL = "/";
export const VTrackURL = "/vTrack";
export const dashboardURL = "/dashboard";
export const resourceDashboardURL = "/resource-dashboard";
export const sessionReportingURL = "/session-reporting";